module.exports = __webpack_public_path__ + "media/bom/no-perfect-match-9cdd3c4e.png";